module.exports = __webpack_public_path__ + "img/google_playstore_white.e2862a8d.png";